<template>
  <v-container fluid class="px-6 py-6">
    <v-row>
      <v-col lg="12" >
        <h3 class="text-h5 font-weight-bold mb-4">User Profile</h3>

        <v-expansion-panels v-model="openPanel">
          <v-expansion-panel>
            <v-expansion-panel-header>
              Profile Information
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-form
                ref="profileForm"
                v-model="profileFormValid"
                @submit.prevent="updateProfile"
              >
                <label class="text-xs text-typo font-weight-bolder ms-1"
                  >Email</label
                >
                <v-text-field
                  v-model="profile.email"
                  :rules="emailRules"
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                  class="
                    font-size-input
                    placeholder-lighter
                    text-light-input
                    border border-radius-md
                    mt-2
                  "
                  hide-details="auto"
                ></v-text-field>
                <v-row>
                  <v-col>
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                      >First Name</label
                    >
                    <v-text-field
                      v-model="profile.firstName"
                      required
                      outlined
                      dense
                      prepend-inner-icon="mdi-account"
                      class="
                        font-size-input
                        placeholder-lighter
                        text-light-input
                        border border-radius-md
                        mt-2
                      "
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <label class="text-xs text-typo font-weight-bolder ms-1"
                      >Last Name</label
                    >
                    <v-text-field
                      v-model="profile.lastName"
                      required
                      outlined
                      dense
                      prepend-inner-icon="mdi-account"
                      class="
                        font-size-input
                        placeholder-lighter
                        text-light-input
                        border border-radius-md
                        mt-2
                      "
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-btn
                  color="primary"
                  type="submit"
                  width="100%"
                  :loading="loading"
                  :disabled="!profileFormValid"
                  dark
                  class="mt-4"
                >
                  Update Profile
                </v-btn>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              Change Password
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-btn
                color="secondary"
                @click="resetPassword"
                :loading="loading"
                dark
                class="mt-4"
              >
                Send Password Reset Email
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12">
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="3000"
        >
          {{ snackbarText }}
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import fb from "../plugins/firebase";
const auth = fb.auth;
import { sendPasswordResetEmail } from "firebase/auth";

export default {
  name: "UserProfile",
  components: {
    //DashboardLayout
  },
  data() {
    return {
      openPanel: 0,
      profileFormValid: false,
      loading: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      profile: {
        email: "",
        firstName: "",
        lastName: "",
      },
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth;
    },
  },
  methods: {
    async updateProfile() {
      if (!this.$refs.profileForm.validate()) return;

      this.loading = true;
      try {
        await this.$store.dispatch("updateProfile", this.profile);
        this.snackbarText = "Profile updated successfully";
        this.snackbarColor = "success";
        this.snackbar = true;
      } catch (error) {
        this.snackbarText = error.message || "Failed to update profile";
        this.snackbarColor = "error";
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
    async resetPassword() {
      if (!this.profile.email) {
        this.snackbarText = "Please ensure your email is set in your profile";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      this.loading = true;
      try {
        const baseUrl = window.location.origin;
        const actionCodeSettings = {
          url: `${baseUrl}/reset-password-confirm`,
          handleCodeInApp: true,
        };

        await sendPasswordResetEmail(
          auth,
          this.profile.email,
          actionCodeSettings
        );
        this.snackbarText = "Password reset email sent. Please check your inbox and follow the link to reset your password.";
        this.snackbarColor = "success";
        this.snackbar = true;
      } catch (error) {
        console.error("Error resetting password:", error);
        this.snackbarText = error.message || "Failed to send reset email";
        this.snackbarColor = "error";
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    // Initialize profile data from store state
    const auth = this.$store.state.auth;
    if (auth) {
      this.profile = {
        email: auth.email || "",
        firstName: auth.firstName || "",
        lastName: auth.lastName || "",
      };
    }
  },
  watch: {
    "$store.state.auth": {
      handler(newAuth) {
        if (newAuth) {
          this.profile = {
            email: newAuth.email || "",
            firstName: newAuth.firstName || "",
            lastName: newAuth.lastName || "",
          };
        }
      },
      immediate: true,
    },
  },
};
</script>
